module.exports = ".password-btn{padding:5px}\n"